import React from 'react';
import { assets, BRAND } from '../../assets/branding';

// Reusable ReasonVisionX brand lockup.
// variant: 'full' (mark + wordmark) | 'mark' (square product mark)
// onDark: when placed on a dark surface, the full lockup is framed in a light
// pill so the deep-navy "Reason" wordmark stays legible (never invert the art).
export const BrandLogo = ({
  variant = 'full',
  onDark = false,
  showTagline = false,
  className = '',
  imgClassName = '',
  markSize = 40,
  'data-testid': testId = 'brand-logo',
}) => {
  if (variant === 'mark') {
    return (
      <img
        src={assets.mark}
        alt={`${BRAND.productName} logo`}
        width={markSize}
        height={markSize}
        className={`object-contain ${className}`}
        style={{ width: markSize, height: markSize }}
        data-testid={testId}
      />
    );
  }

  const img = (
    <img
      src={assets.logo}
      alt={`${BRAND.productName} — ${BRAND.tagline}`}
      className={`object-contain ${imgClassName}`}
      data-testid={testId}
    />
  );

  return (
    <div className={`flex flex-col ${className}`}>
      {onDark ? (
        <div className="bg-white/95 rounded-xl px-4 py-3 shadow-lg shadow-black/20 inline-flex">
          {img}
        </div>
      ) : (
        img
      )}
      {showTagline && (
        <p className={`text-sm mt-3 ${onDark ? 'text-white/80' : 'text-muted-foreground'}`}>
          {BRAND.tagline}
        </p>
      )}
    </div>
  );
};

export default BrandLogo;
